<template>
    <div @click.stop="$emit('click')" class="d-flex flex-row align-items-center badge badge-light rounded-pill position-relative pr-3">
        <AssetIcon :file="file" />
        <div class="mr-1 d-flex flex-column align-items-start">
            <div class="mb-1">{{ file.asset_title }}</div>
            <div class="font-weight-normal">{{ getFileType }}</div>
        </div>

        <div
            v-if="showRemove"
            @click="$emit('remove')"
            class="rounded-pill badge badge-danger position-absolute py-1"
            style="top: 0; right: 0; transform: translate(50%, -40%); font-size: 0.8rem; cursor: pointer;"
        >
            <b-icon icon="x"/>
        </div>
    </div>
</template>

<script>
import AssetIcon from './AssetIcon.vue';

export default {
    components: {
        AssetIcon,
    },
    props: {
        file: Object,
        showRemove: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
		getFileType() {
            switch (this.file.asset_extension) {
                case 'pdf':
                    return this.$t('pdf');
                case 'doc':
                case 'docx':
                    return this.$t('word-document');
                case 'jpeg':
                case 'jpg':
                case 'gif':
                case 'png':
                    return this.$t('image');;
                default:
                    return this.$t('file');;
            }
        }
    },
}
</script>
